//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


export default {
  props: {
    product: Object,
    catId: String,
    smallTicketItems: {
      type: Boolean,
      default: false
    }
  }
}
